'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _has = require('./has');

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'get',
    immutable: 'get',
    record: 'get',
    object: function object(key) {
        var notFoundValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return function (value) {
            return (0, _has2.default)(key)(value) ? value[key] : notFoundValue;
        };
    },
    array: function array(key) {
        var notFoundValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return function (value) {
            return (0, _has2.default)(key)(value) ? key < 0 ? value[key + value.length] : value[key] : notFoundValue;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/get.js
// module id = 38
// module chunks = 35783957827783